// import arrowDownGray from "@/assets/images/user/arrowDownGray.svg";
// import schedule1 from "@/assets/images/user/schedule1.jpg";
// import schedule2 from "@/assets/images/user/schedule2.jpg";
// import scheduleArtLogo from "@/assets/images/user/scheduleArtLogo.svg";
// import scheduleLogo1 from "@/assets/images/user/scheduleLogo1.svg";
// import scheduleLogo2 from "@/assets/images/user/scheduleLogo2.svg";
// import scheduleLogo3 from "@/assets/images/user/scheduleLogo3.svg";
// import scheduleLogo4 from "@/assets/images/user/scheduleLogo4.svg";
// import tableArt from "@/assets/images/user/tableArt.svg";
// import tableDay1 from "@/assets/images/user/tableDay1.svg";
// import tableDay2 from "@/assets/images/user/tableDay2.svg";
// import tableFesta from "@/assets/images/user/tableFesta.svg";
// import tableFocus from "@/assets/images/user/tableFocus.svg";
// import tablePlay from "@/assets/images/user/tablePlay.svg";
// import tableStage1 from "@/assets/images/user/tableStage1.svg";
// import tableStage2 from "@/assets/images/user/tableStage2.svg";
import icArrowDropDown from "@/assets/images/user/icArrowDropDown.png";
// xl 미만에서는 표 대신 스케줄 이미지를 보여주고, 눌러서 확대/축소한다.
import schedule2026Day1 from "@/assets/images/user/schedule2026Day1.jpg";
import schedule2026Day1Zoom from "@/assets/images/user/schedule2026Day1Zoom.jpg";
import schedule2026Day2 from "@/assets/images/user/schedule2026Day2.jpg";
import schedule2026Day2Zoom from "@/assets/images/user/schedule2026Day2Zoom.jpg";
// 콜라보레이션 로고. 메인(Main.tsx)의 로고는 160x80 셀(여백 포함)이라 타임테이블에는 쓰지 않고,
// 여백 없는 전용 이미지를 쓴다. 화살표 포함 모두 시안 크기의 1.5배수라 표시 폭을 명시해 준다.
import schedule2026Logo1 from "@/assets/images/user/schedule2026Logo1.png";
import schedule2026Logo2 from "@/assets/images/user/schedule2026Logo2.png";
import schedule2026Logo3 from "@/assets/images/user/schedule2026Logo3.png";
import schedule2026Logo4 from "@/assets/images/user/schedule2026Logo4.png";
import schedule2026Logo5 from "@/assets/images/user/schedule2026Logo5.png";
import schedule2026Logo6 from "@/assets/images/user/schedule2026Logo6.png";
import schedule2026Logo7 from "@/assets/images/user/schedule2026Logo7.png";
import schedule2026Pre from "@/assets/images/user/schedule2026Pre.jpg";
// 타임테이블 헤더(시안에서 3배수로 내려받음). 1일차/2일차의 열 너비가 달라 각각 따로 쓴다.
import table2026Art1 from "@/assets/images/user/table2026Art1.png";
import table2026Art2 from "@/assets/images/user/table2026Art2.png";
import table2026Day1 from "@/assets/images/user/table2026Day1.png";
import table2026Day2 from "@/assets/images/user/table2026Day2.png";
import table2026Festa1 from "@/assets/images/user/table2026Festa1.png";
import table2026Festa2 from "@/assets/images/user/table2026Festa2.png";
import table2026Focus1 from "@/assets/images/user/table2026Focus1.png";
import table2026Play1 from "@/assets/images/user/table2026Play1.png";
import table2026Play2 from "@/assets/images/user/table2026Play2.png";
import table2026Pre from "@/assets/images/user/table2026Pre.png";
import table2026Stage from "@/assets/images/user/table2026Stage.png";
import table2026StagePre from "@/assets/images/user/table2026StagePre.png";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";
import ImgZoomPop from "@/components/user/popup/ImgZoomPop";

/* ===== 타임테이블 (PC 전용) =====
   시안(Figma) 기준 폭 1400px.
   - 본문은 110px 짜리 10행이고, 가로 구분선은 각 행의 "위쪽"에만 있다(마지막 행 아래는 없음).
   - 카드는 행 안에서 위아래 8px, 좌우 4px 씩 띄운다.
   - 열 너비는 시안 좌표를 1400 으로 나눈 % 로 넣었다(헤더와 본문의 열 경계가 시안에서 조금 다르다).
   태블릿/모바일은 스케줄 이미지로 대체 예정이라 아직 COMING SOON 을 그대로 둔다. */

type Tone = "stage" | "play" | "art" | "focus" | "festa";

// 카테고리별 테두리 / hover 배경 / 본문 텍스트 그라디언트. 2025 타임테이블과 같은 팔레트다.
// 카테고리별 색(시안 실측). 테두리와 본문 글자는 같은 좌→우 그라디언트를 쓰고,
// hover 하면 카드 배경이 위(흰색)→아래(연한 색) 세로 그라디언트로 바뀐다. 테두리 두께는 그대로 2px.
// stage #E9492A→#FE7E70 / hover #FFF6E5   play  #01B1AA→#43DCD6 / hover #DEFFFE
// art   #D02F8B→#F369B8 / hover #FFF2F9   focus #FABF01→#FEDA63 / hover #FFF7DF
// festa #016CB8→#339BE4 / hover #DEF0FF
const tone: Record<Tone, { card: string; text: string }> = {
    stage: {
        card: "before:[background-image:linear-gradient(#fff,#fff),linear-gradient(90deg,#E9492A,#FE7E70)] hover:before:[background-image:linear-gradient(#fff,#FFF6E5),linear-gradient(90deg,#E9492A,#FE7E70)]",
        text: "from-[#E9492A] to-[#FE7E70]",
    },
    play: {
        card: "before:[background-image:linear-gradient(#fff,#fff),linear-gradient(90deg,#01B1AA,#43DCD6)] hover:before:[background-image:linear-gradient(#fff,#DEFFFE),linear-gradient(90deg,#01B1AA,#43DCD6)]",
        text: "from-[#01B1AA] to-[#43DCD6]",
    },
    art: {
        card: "before:[background-image:linear-gradient(#fff,#fff),linear-gradient(90deg,#D02F8B,#F369B8)] hover:before:[background-image:linear-gradient(#fff,#FFF2F9),linear-gradient(90deg,#D02F8B,#F369B8)]",
        text: "from-[#D02F8B] to-[#F369B8]",
    },
    focus: {
        card: "before:[background-image:linear-gradient(#fff,#fff),linear-gradient(90deg,#FABF01,#FEDA63)] hover:before:[background-image:linear-gradient(#fff,#FFF7DF),linear-gradient(90deg,#FABF01,#FEDA63)]",
        text: "from-[#FABF01] to-[#FEDA63]",
    },
    festa: {
        card: "before:[background-image:linear-gradient(#fff,#fff),linear-gradient(90deg,#016CB8,#339BE4)] hover:before:[background-image:linear-gradient(#fff,#DEF0FF),linear-gradient(90deg,#016CB8,#339BE4)]",
        text: "from-[#016CB8] to-[#339BE4]",
    },
};

// 카드 배경·테두리는 ::before 오버레이가 전담한다. 테두리가 좌→우 그라디언트라
// 배경을 2겹(안쪽 카드색 / 바깥 테두리 그라디언트)으로 깔아 그리고, hover 시 2px → 4px 로 두꺼워진다.
// 오버레이는 absolute 라서 두께가 변해도 본문 위치가 밀리지 않는다.
const cardClass =
    "relative isolate flex h-full flex-col items-center rounded-[12px] text-center font-['GongGothicMedium'] leading-[1.5] text-black before:absolute before:inset-0 before:-z-10 before:rounded-[12px] before:border-2 before:border-transparent before:content-[''] before:[background-clip:padding-box,border-box] before:[background-origin:border-box] hover:before:border-4";
// td 에도 행 높이를 줘야 rowSpan 이 걸린 칸의 높이가 확정되고, 그 안의 카드 h-full 이 먹는다.
const cellClass = "h-[120px] p-[8px_4px]";
// 시안에는 시간열 오른쪽에 본문 전체 높이를 지나는 세로선이 하나 있다.
const timeCellClass =
    "h-[120px] border-r border-[#ddd] bg-[rgba(255,255,255,0.4)] text-center font-['GongGothicLight'] text-[18px] leading-[1.2] text-black";
// 시안: 무대 카드 제목 24px / 출연·부제 18px 그라디언트(#FF5B2E → #FF7F71), 줄간격 1.4
const stageTitleClass = "text-[24px] leading-[1.4] tracking-[-0.48px]";
const stageSubClass =
    "bg-gradient-to-r from-[#FF5B2E] to-[#FF7F71] bg-clip-text text-[18px] leading-[1.4] text-transparent";
const stageSubListClass = `flex flex-col gap-[16px] ${stageSubClass}`;
const noteClass = "absolute bottom-[20px] right-[20px] font-['GongGothicMedium'] text-[18px] text-black";

function Card({ tone: t, className = "", children }: { tone: Tone; className?: string; children: React.ReactNode }) {
    return <div className={`${cardClass} ${tone[t].card} ${className}`}>{children}</div>;
}

/** 제목 + 화살표 + 목록 구성의 세로로 긴 카드. pt 로 제목 위치를 잡아 열끼리 제목 높이를 맞춘다. */
function ProgramCard({
    tone: t,
    title,
    pt,
    children,
}: {
    tone: Tone;
    title: string;
    pt: string;
    children: React.ReactNode;
}) {
    return (
        <Card tone={t} className={`gap-[12px] ${pt}`}>
            {/* 시안: 제목 박스 34px, 제목~화살표~목록 간격 각각 12px */}
            <p className="text-[20px] leading-[34px]">{title}</p>
            <img src={icArrowDropDown} alt="" className="w-[24px]" />
            <div
                className={`flex flex-col gap-[22px] bg-gradient-to-r bg-clip-text text-[18px] text-transparent ${tone[t].text}`}
            >
                {children}
            </div>
        </Card>
    );
}

/** 콜라보레이션 로고 목록. 시안 기준 간격 48px, 로고마다 표시 폭이 다르고 가운데 정렬이다. */
function LogoList({ logos }: { logos: { src: string; alt: string; className: string }[] }) {
    return (
        <div className="flex flex-col items-center gap-[48px]">
            {logos.map(logo => (
                <img key={logo.alt} src={logo.src} alt={logo.alt} className={logo.className} />
            ))}
        </div>
    );
}

// 시안 표시 폭(= 이미지 파일 크기 / 1.5)
const festaLogos = {
    indiecraft: { src: schedule2026Logo1, alt: "인디크래프트", className: "w-[166.67px]" },
    illustar: { src: schedule2026Logo2, alt: "일러스타 페스", className: "w-[164px]" },
    gv2026: { src: schedule2026Logo3, alt: "GV2026", className: "w-[160px]" },
    subculture: { src: schedule2026Logo4, alt: "한국 서브컬처 공모전", className: "w-[163.33px]" },
    gsdc: { src: schedule2026Logo5, alt: "AI GSDC", className: "w-[166px]" },
    pokemon: {
        src: schedule2026Logo6,
        alt: "포켓몬 카드 게임 2026 성남CITY 배틀 토너먼트",
        className: "w-[158px]",
    },
    // 가로형 로고로 교체(1107x272). 표시 폭은 시안 타임테이블 기준 242px / 1.5.
    meister: {
        src: schedule2026Logo7,
        alt: "2026 경기게임마이스터고 졸업 작품 전시회",
        className: "w-[161.33px]",
    },
};

const day1Times = [
    ["10:00", "13:00"],
    ["13:00", "14:00"],
    ["14:00", "15:00"],
    ["15:00", "16:00"],
    ["16:00", "17:00"],
    ["17:00", "18:00"],
    ["18:00", "19:00"],
    ["19:00", "20:00"],
    ["20:00", "21:00"],
    ["21:00", "22:00"],
];
const day2Times: string[][] = [["12:00", "13:00"], ...day1Times.slice(1)];

function TimeCell({ time }: { time: string[] }) {
    return (
        <td className={timeCellClass}>
            {time[0]}
            <br />-<br />
            {time[1]}
        </td>
    );
}

/** 체험 프로그램 목록(1·2일차 동일) */
const playItems = (
    <>
        <p>GXG 코스튬 체험존</p>
        <p>GXG 플레이 라운지</p>
        <p>브랜드 체험존</p>
        <p>Cool Station</p>
        <p>GXG 캠퍼스 아케이드</p>
    </>
);

export default function Schedule() {
    // const baseBoxClass =
    //     "font-['GongGothicMedium'] text-center h-full flex flex-col items-center bg-white rounded-[8px] transition-all duration-100 relative before:content-[''] before:absolute before:inset-0 before:w-full before:h-full before:rounded-[8px] before:transition-all before:duration-[50ms] before:border-2 hover:before:border-4";
    // const stageBoxClass = `${baseBoxClass} gap-[8px] justify-center before:border-[#FF5B2E] hover:bg-[#FEF7F6]`;
    // const playBoxClass = `${baseBoxClass} gap-[4px] pt-[220px] before:border-[#00A8A0] hover:bg-[#FAFFFF]`;
    // const artBoxClass = `${baseBoxClass} gap-[4px] pt-[220px] before:border-[#EB008B] hover:bg-[#FFF8FC]`;
    // const focusBoxClass = `${baseBoxClass} gap-[4px] justify-center before:border-[#F6921E] hover:bg-[#FFF8EF]`;
    // const festaBoxClass = `${baseBoxClass} gap-[4px] pt-[220px] before:border-[#006AC1] hover:bg-[#F7FBFF]`;
    // const stageTextClass = "bg-gradient-to-r from-[#FF5B2E] to-[#FF7F71] bg-clip-text text-transparent";
    // const playTextClass = "bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent";
    // const artTextClass = "bg-gradient-to-r from-[#EB008B] to-[#EE579E] bg-clip-text text-transparent";
    // const focusTextClass = "bg-gradient-to-r from-[#F6921E] to-[#F9A643] bg-clip-text text-transparent";
    // const festaTextClass = "bg-gradient-to-r from-[#006AC1] to-[#209CEF] bg-clip-text text-transparent";

    return (
        <div className="mx-auto w-full max-w-[1400px] px-[20px] xl:px-0">
            <TitleBox title="SCHEDULE" text="행사 스케줄" />
            <div className="flex flex-col gap-[40px] p-[28px_0_60px] md:gap-[100px] md:p-[48px_0_100px] xl:pb-[160px]">
                <div className="flex flex-col gap-[20px] md:gap-[28px] xl:gap-[40px]">
                    {/* D-1 은 한 줄짜리 표라 안내 문구가 표 아래가 아니라 제목 옆에 붙는다(시안).
                        폭이 좁으면 제목 옆에 다 안 들어가서 xl 미만에서는 제목 아래로 내린다. */}
                    <div className="flex flex-col gap-[8px] xl:flex-row xl:items-end xl:justify-between xl:gap-0">
                        <SubTitle title="D-1 타임테이블" />
                        <p className="font-['GongGothicMedium'] text-[12px] text-black md:text-[16px] xl:text-[18px]">
                            * 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.
                        </p>
                    </div>
                    {/* 시안 폭: PRE EVENT 100 / THE STAGE 320 / 카드 972, 사이 간격 4 (1400 기준) */}
                    <div className="hidden gap-[0.2857%] xl:flex">
                        <div className="w-[7.1428%]">
                            <img src={table2026Pre} alt="PRE EVENT 9/10 (목)" className="w-full" />
                        </div>
                        <div className="w-[22.8571%]">
                            <img src={table2026StagePre} alt="THE STAGE - STREET STAGE" className="w-full" />
                        </div>
                        {/* 카드는 열 안에서 좌우 8px 씩 들어간다 */}
                        <div className="w-[69.4286%] px-[0.5714%]">
                            <Card tone="stage" className="justify-center gap-[8px]">
                                <p
                                    className={`bg-gradient-to-r bg-clip-text text-[28px] leading-[1.4] text-transparent ${tone.stage.text}`}
                                >
                                    GXG 버스킹 타임 - 게임사 직장인 밴드 공연
                                </p>
                                <p className="text-[20px] leading-[1.4]">오후 17:00 - 21:00 &nbsp;📍판교 콘텐츠 거리</p>
                            </Card>
                        </div>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule2026Pre} alt="D-1 타임테이블" />
                    </div>
                </div>
                <div className="flex flex-col gap-[20px] md:gap-[28px] xl:gap-[40px]">
                    <SubTitle title="1일차 타임테이블" />
                    <div className="relative hidden xl:block">
                        {/* 헤더는 시안 폭 그대로: DAY 100 / THE STAGE 320 / 나머지 240, 사이 간격 4 (1400 기준) */}
                        <div className="flex gap-[0.2857%]">
                            <div className="w-[7.1428%]">
                                <img src={table2026Day1} alt="DAY 1 9/11 (금)" className="w-full" />
                            </div>
                            <div className="w-[22.8571%]">
                                <img src={table2026Stage} alt="THE STAGE" className="w-full" />
                            </div>
                            <div className="w-[17.1428%]">
                                <img src={table2026Play1} alt="THE PLAY" className="w-full" />
                            </div>
                            <div className="w-[17.1428%]">
                                <img src={table2026Art1} alt="THE ART" className="w-full" />
                            </div>
                            <div className="w-[17.1428%]">
                                <img src={table2026Focus1} alt="THE FOCUS" className="w-full" />
                            </div>
                            <div className="w-[17.1428%]">
                                <img src={table2026Festa1} alt="THE FESTA" className="w-full" />
                            </div>
                        </div>
                        <table className="mt-[8px] w-full table-fixed">
                            <colgroup>
                                <col className="w-[7.4286%]" />
                                <col className="w-[23.1429%]" />
                                <col className="w-[17.4286%]" />
                                <col className="w-[17.4286%]" />
                                <col className="w-[17.4286%]" />
                                <col className="w-[17.1429%]" />
                            </colgroup>
                            <tbody className="bg-[#F8F8F8] [background-image:repeating-linear-gradient(to_bottom,#ddd_0_1px,transparent_1px_120px)]">
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[0]} />
                                    <td className={cellClass} rowSpan={5} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                    <td className={cellClass} rowSpan={9}>
                                        {/* THE FOCUS 만 한 행 위(10:00)에서 시작해서, 제목 높이를 다른 열과 맞추려면 pt 가 한 행만큼 더 크다. */}
                                        <ProgramCard tone="focus" title="네트워킹 프로그램" pt="pt-[350px]">
                                            <p>
                                                Connect Fair <br />
                                                K-game 수출상담회
                                            </p>
                                            <p>
                                                Game Tech Night <br />
                                                with GXG and <br />
                                                Microsoft
                                            </p>
                                        </ProgramCard>
                                    </td>
                                    <td className={cellClass} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[1]} />
                                    <td className={cellClass} rowSpan={8}>
                                        <ProgramCard tone="play" title="체험 프로그램" pt="pt-[230px]">
                                            {playItems}
                                        </ProgramCard>
                                    </td>
                                    <td className={cellClass} rowSpan={8}>
                                        <ProgramCard tone="art" title="전시 프로그램" pt="pt-[230px]">
                                            <p>
                                                GXG 코스튬 갤러리 <br />
                                                스마일게이트 X RZCOS
                                            </p>
                                            <p>GXG 사회공헌 전시</p>
                                            <p>
                                                GXG SOUND TRACK <br />
                                                전시
                                            </p>
                                        </ProgramCard>
                                    </td>
                                    <td className={cellClass} rowSpan={8}>
                                        <ProgramCard tone="festa" title="GXG 콜라보레이션" pt="pt-[230px]">
                                            <LogoList
                                                logos={[
                                                    festaLogos.indiecraft,
                                                    festaLogos.illustar,
                                                    festaLogos.gv2026,
                                                    festaLogos.meister,
                                                ]}
                                            />
                                        </ProgramCard>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[2]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[3]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[4]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[5]} />
                                    {/* 사전 공연은 시안에서 행 아래쪽에 붙는 낮은 카드 */}
                                    <td className={`${cellClass} align-bottom`}>
                                        <Card tone="stage" className="!h-[72px] justify-center gap-[2px]">
                                            <p className={stageTitleClass}>사전공연</p>
                                            <p className={stageSubClass}>우주골치클럽</p>
                                        </Card>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[6]} />
                                    <td className={cellClass}>
                                        <Card tone="stage" className="justify-center gap-[2px]">
                                            <p className={stageTitleClass}>
                                                GXG 2026 <br />
                                                개막선언 &amp; 축하공연
                                            </p>
                                            <p className={stageSubClass}>다이나믹 듀오</p>
                                        </Card>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[7]} />
                                    <td className={cellClass} rowSpan={3}>
                                        <Card tone="stage" className="justify-center gap-[2px]">
                                            <p className={stageTitleClass}>
                                                The 3<span className="align-super text-[0.7em]">rd</span> GXG <br />
                                                SOUND TRACK
                                            </p>
                                            <p className={stageSubClass}>GXG 2026 게임음악 경연대회</p>
                                        </Card>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[8]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day1Times[9]} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                </tr>
                            </tbody>
                        </table>
                        <p className={noteClass}>* 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.</p>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule2026Day1} zoomImg={schedule2026Day1Zoom} alt="1일차 타임테이블" />
                    </div>
                    {/* <div className="relative hidden xl:block">
                        <table>
                            <colgroup>
                                <col className="w-[11.4%]" />
                                <col className="w-[14.6%]" />
                                <col className="w-[14.6%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th className="pb-[12px] border-b border-[#ddd]">
                                        <img src={tableDay1} alt="day1" />
                                    </th>
                                    <th className="p-[0_0_12px_8px] border-b border-[#ddd]" colSpan={2}>
                                        <img src={tableStage1} alt="the stage" className="w-full" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tablePlay} alt="the play" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableArt} alt="the art" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableFocus} alt="the focus" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableFesta} alt="the festa" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        10:00 - 13:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={5}>
                                        <div className={focusBoxClass}>
                                            <p className="text-[20px]">GXG 컨퍼런스</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`text-[18px] ${focusTextClass}`}>
                                                <p>
                                                    GXG 2025 컨퍼런스 <br />
                                                    NEXT PLAY <br />
                                                    with Microsoft <br />
                                                    Cloud & AI
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        13:00 - 14:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]">
                                        <div className={stageBoxClass}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={playBoxClass}>
                                            <p className="text-[20px]">체험 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${playTextClass}`}>
                                                <p>브랜드 체험존</p>
                                                <p>GXG 마켓</p>
                                                <p>GXG 플레이 라운지</p>
                                                <p>
                                                    Cool Station <br />
                                                    with 동아오츠카
                                                </p>
                                                <p>GXG 캠퍼스 아케이드</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={artBoxClass}>
                                            <p className="text-[20px]">전시 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${artTextClass}`}>
                                                <p>GXG 씨어터</p>
                                                <p>GXG 아트북 라운지</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={festaBoxClass}>
                                            <p className="text-[20px]">GXG 콜라보레이션</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${festaTextClass}`}>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo1} alt="이미지" />
                                                    <p>인디게임 전시</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo2} alt="이미지" />
                                                    <p>서브컬쳐 이벤트</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo3} alt="이미지" />
                                                    <p>로컬 브랜드 마켓</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo4} alt="이미지" />
                                                    <p>진로탐색 프로그램</p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        14:00 - 15:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={7}>
                                        <div className={stageBoxClass}>
                                            <p className="text-[20px]">GXG 버스킹 타임</p>
                                            <div className={`text-[18px] flex flex-col gap-[16px] ${stageTextClass}`}>
                                                <p>일러스타 DJ 커넥트 쁘띠</p>
                                                <p>직장인 밴드</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        15:00 - 16:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        16:00 - 17:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        17:00 - 18:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px] align-bottom">
                                        <div className={`${stageBoxClass} !h-[calc(100%-40px)] !gap-0`}>
                                            <p className="text-[20px]">사전 공연</p>
                                            <p className={`text-[18px] ${stageTextClass}`}>밴드 리프(Lif)</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        18:00 - 19:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]">
                                        <div className={stageBoxClass}>
                                            <p className="text-[20px]">
                                                GXG 2025 <br />
                                                개막식&축하 공연
                                            </p>
                                            <p className={`text-[18px] ${stageTextClass}`}>에일리</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        19:00 - 20:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px] align-top" rowSpan={3}>
                                        <div className={`${stageBoxClass} !h-[calc(100%-30px)]`}>
                                            <p className="text-[18px] leading-[1.5]">
                                                GXG 2025 <br />
                                                게임음악 경연대회 <br />
                                                <span className="flex items-start justify-center">
                                                    The 2
                                                    <span className="text-[13px] font-['GongGothicLight']">nd</span>
                                                    &nbsp;GXG
                                                </span>
                                                SOUND TRACK
                                            </p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        20:00 - 21:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        21:00 - 22:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top">
                                        <div className={`${stageBoxClass} !h-[calc(100%-30px)]`}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" colSpan={4}></td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="text-[18px] font-['GongGothicMedium'] absolute bottom-[20px] right-[20px]">
                            * 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.
                        </p>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule1} />
                    </div> */}
                </div>
                <div className="flex flex-col gap-[20px] md:gap-[28px] xl:gap-[40px]">
                    <SubTitle title="2일차 타임테이블" />
                    <div className="relative hidden xl:block">
                        {/* 2일차 헤더: DAY 100 / THE STAGE 320 / 나머지 321.3, 사이 간격 4 (1400 기준) */}
                        <div className="flex gap-[0.2857%]">
                            <div className="w-[7.1428%]">
                                <img src={table2026Day2} alt="DAY 2 9/12 (토)" className="w-full" />
                            </div>
                            <div className="w-[22.8571%]">
                                <img src={table2026Stage} alt="THE STAGE" className="w-full" />
                            </div>
                            <div className="w-[22.9524%]">
                                <img src={table2026Play2} alt="THE PLAY" className="w-full" />
                            </div>
                            <div className="w-[22.9524%]">
                                <img src={table2026Art2} alt="THE ART" className="w-full" />
                            </div>
                            <div className="w-[22.9524%]">
                                <img src={table2026Festa2} alt="THE FESTA" className="w-full" />
                            </div>
                        </div>
                        <table className="mt-[8px] w-full table-fixed">
                            <colgroup>
                                <col className="w-[7.4286%]" />
                                <col className="w-[23.1429%]" />
                                <col className="w-[23.2381%]" />
                                <col className="w-[23.2381%]" />
                                <col className="w-[22.9524%]" />
                            </colgroup>
                            <tbody className="bg-[#F8F8F8] [background-image:repeating-linear-gradient(to_bottom,#ddd_0_1px,transparent_1px_120px)]">
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[0]} />
                                    <td className={cellClass} rowSpan={3}>
                                        <Card tone="stage" className="justify-center gap-[12px]">
                                            <p className={stageTitleClass}>일러스타 페스 스테이지</p>
                                            <div className={stageSubListClass}>
                                                <p>한국 서브컬처 공모전 &apos;코스프레 댄스&apos;</p>
                                                <p>인디 아이돌 쇼케이스</p>
                                                <p>꽃감이의 게임 뮤직 LIVE</p>
                                            </div>
                                        </Card>
                                    </td>
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[1]} />
                                    <td className={cellClass} rowSpan={8}>
                                        <ProgramCard tone="play" title="체험 프로그램" pt="pt-[150px]">
                                            {playItems}
                                        </ProgramCard>
                                    </td>
                                    <td className={cellClass} rowSpan={8}>
                                        <ProgramCard tone="art" title="전시 프로그램" pt="pt-[150px]">
                                            <p>
                                                GXG 코스튬 갤러리 <br />
                                                스마일게이트 X RZCOS
                                            </p>
                                            <p>GXG 사회공헌 전시</p>
                                            <p>GXG SOUND TRACK 전시</p>
                                        </ProgramCard>
                                    </td>
                                    <td className={cellClass} rowSpan={8}>
                                        <ProgramCard tone="festa" title="GXG 콜라보레이션" pt="pt-[150px]">
                                            <LogoList
                                                logos={[
                                                    festaLogos.indiecraft,
                                                    festaLogos.illustar,
                                                    festaLogos.subculture,
                                                    festaLogos.gsdc,
                                                    festaLogos.pokemon,
                                                ]}
                                            />
                                        </ProgramCard>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[2]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[3]} />
                                    {/* AI GSDC 시상식도 사전 공연과 같이 행 아래쪽에 붙는 낮은 카드 */}
                                    <td className={`${cellClass} align-bottom`}>
                                        <Card tone="stage" className="!h-[72px] justify-center">
                                            <p className={stageTitleClass}>AI GSDC 시상식</p>
                                        </Card>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[4]} />
                                    <td className={cellClass} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[5]} />
                                    <td className={cellClass} rowSpan={5}>
                                        <Card tone="stage" className="justify-center gap-[12px]">
                                            <p className={stageTitleClass}>GXG 갈라 콘서트</p>
                                            <div className={stageSubListClass}>
                                                <p>앙상블 힐</p>
                                                <p>국립국악원 창작악단</p>
                                                <p>GXG SOUND TRACK</p>
                                            </div>
                                        </Card>
                                    </td>
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[6]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[7]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[8]} />
                                </tr>
                                <tr className="h-[120px]">
                                    <TimeCell time={day2Times[9]} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                    <td className={cellClass} />
                                </tr>
                            </tbody>
                        </table>
                        <p className={noteClass}>* 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.</p>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule2026Day2} zoomImg={schedule2026Day2Zoom} alt="2일차 타임테이블" />
                    </div>
                    {/* <div className="relative hidden xl:block">
                        <table>
                            <colgroup>
                                <col className="w-[11.4%]" />
                                <col className="w-[21.9%]" />
                                <col className="w-[21.9%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th className="pb-[12px] border-b border-[#ddd]">
                                        <img src={tableDay2} alt="day2" />
                                    </th>
                                    <th className="p-[0_0_12px_8px] border-b border-[#ddd]" colSpan={2}>
                                        <img src={tableStage2} alt="the stage" className="w-full" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tablePlay} alt="the play" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableArt} alt="the art" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableFesta} alt="the festa" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        12:00 - 13:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]" rowSpan={3}>
                                        <div className={stageBoxClass}>
                                            <p className="text-[20px]">
                                                일러스타 페스 <br />
                                                스테이지
                                            </p>
                                            <p className={`text-[18px] ${stageTextClass}`}>코스플레이 & 인디아이돌</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        13:00 - 14:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top" rowSpan={2}>
                                        <div className={`${stageBoxClass} !h-[calc(100%+46px)]`}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={playBoxClass}>
                                            <p className="text-[20px]">체험 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${playTextClass}`}>
                                                <p>브랜드 체험존</p>
                                                <p>GXG 마켓</p>
                                                <p>GXG 플레이 라운지</p>
                                                <p>
                                                    Cool Station <br />
                                                    with 동아오츠카
                                                </p>
                                                <p>GXG 캠퍼스 아케이드</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={artBoxClass}>
                                            <p className="text-[20px]">전시 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${artTextClass}`}>
                                                <p>GXG 씨어터</p>
                                                <p>GXG 아트북 라운지</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={festaBoxClass}>
                                            <p className="text-[20px]">GXG 콜라보레이션</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${festaTextClass}`}>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo1} alt="이미지" />
                                                    <p>인디게임 전시</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo2} alt="이미지" />
                                                    <p>서브컬쳐 이벤트</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo3} alt="이미지" />
                                                    <p>로컬 브랜드 마켓</p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        14:00 - 15:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        15:00 - 16:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top" rowSpan={2}>
                                        <div className={`${stageBoxClass} mt-[46px]`}>
                                            <p className="text-[20px]">
                                                GXG <br />
                                                플레이 타임
                                            </p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-bottom" rowSpan={6}>
                                        <div className={`${stageBoxClass} !h-[calc(100%-46px)]`}>
                                            <p className="text-[20px]">GXG 버스킹 타임</p>
                                            <div className={`text-[18px] flex flex-col gap-[16px] ${stageTextClass}`}>
                                                <p>일러스타 DJ 커넥트 쁘띠</p>
                                                <p>직장인 밴드</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        16:00 - 17:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        17:00 - 18:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        18:00 - 19:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px] align-top" rowSpan={4}>
                                        <div className={`${stageBoxClass} !h-[calc(100%-77px)] mt-[46px]`}>
                                            <p className="text-[20px]">GXG 갈라 콘서트</p>
                                            <div className={`text-[18px] flex flex-col gap-[16px] ${stageTextClass}`}>
                                                <p>앙상블 힐</p>
                                                <p>플래직 콰이어</p>
                                                <p>GXG SOUND TRACK</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        19:00 - 20:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        20:00 - 21:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        21:00 - 22:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top">
                                        <div className={`${stageBoxClass} !h-[calc(100%-30px)]`}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" colSpan={3}></td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="text-[18px] font-['GongGothicMedium'] absolute bottom-[20px] right-[20px]">
                            * 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.
                        </p>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule2} />
                    </div> */}
                </div>
            </div>
        </div>
    );
}
